import { MapLocationSelectPage } from '@/pages/buyer/MapLocationSelectPage';
import { DesktopMapLocationSelectPage } from '@/pages/desktop/DesktopMapLocationSelectPage';

export function ResponsiveMapLocationSelectPage() {
  return (
    <>
      {/* Mobile version */}
      <div className="lg:hidden">
        <div className="mobile-container bg-white min-h-screen relative">
          <MapLocationSelectPage />
        </div>
      </div>
      
      {/* Desktop version */}
      <div className="hidden lg:block">
        <DesktopMapLocationSelectPage />
      </div>
    </>
  );
}